import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'

export type ExaminationTestModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const ExaminationTestModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: ExaminationTestModalProps): JSX.Element => {
  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.EXAMINATION_AND_TEST]: {
          ...context[ChatContextSourceType.EXAMINATION_AND_TEST],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => <p>Select if you want to consider your control check results</p>,
    [],
  )

  return (
    <ChatContextBooleanSelector
      title="Control Checks"
      description={description}
      prompt="Do consider control check results"
      currentSelection={
        context[ChatContextSourceType.EXAMINATION_AND_TEST].includeAll
      }
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
